import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setRoutesList } from "src/reducers/routes";
import { dummyRoutes } from "src/constants/dummyRoutes";

// ✅ Helper to safely extract ID
const extractId = (input: any): string | null => {
  if (!input) return null;

  if (typeof input === "string") return input;

  if (typeof input === "object" && input.id) return input.id;

  return null;
};

// ✅ GET ROUTES LIST
export const getRoutesListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(`/api/v1/admin/routes?${query}`);
      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setRoutesList(dummyRoutes));
        return dummyRoutes;
      }

      // ✅ 🔥 FIX: MATCH UI STRUCTURE
      const formattedData = {
        result: {
          data: apiResponse.data.data.map((item: any) => ({
            id: item.id,
            routeStop: item.routeStop,
            landmark: item.landmark,

            address: item.address,
            pincode: item.pincode,

            // ✅ FIX: UI uses lat/lng
            lat: item.latitude,
            lng: item.longitude,

            // ✅ FIX: UI expects status (1/0)
            status: item.isActive ? 1 : 0,

            // ✅ FIX: UI uses createdOn
            createdOn: new Date(item.createdAt).toLocaleString(),

            // ✅ FIX: UI expects captain string
            captain: item?.captain?.fullName || "-",
          })),
          total: apiResponse.data.total,
        },
      };

      dispatch(setRoutesList(formattedData));
      return formattedData;
    } catch (err) {
      dispatch(setRoutesList(dummyRoutes));
      return dummyRoutes;
    }
  };

// ✅ TOGGLE ROUTE STATUS
export const updateRouteStatusAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);

      if (!id) {
        throw new Error("Invalid route id");
      }

      const res = await instance.put(
        `/api/v1/admin/routes/${id}/toggle-status`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DELETE ROUTE
export const deleteRouteAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);

      if (!id) {
        throw new Error("Invalid route id");
      }

      const res = await instance.delete(
        `/api/v1/admin/deleteRoute/${id}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };